import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex whitespace-nowrap" }
const _hoisted_3 = { class: "w-full text-right" }
const _hoisted_4 = {
  key: 0,
  class: "text-right pt-1 text-sm"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_6 = { class: "rounded-md shadow-sm pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Autosuggest = _resolveComponent("Autosuggest")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Autosuggest, {
          ref: "autosuggest",
          defaultQuery: _ctx.defaultQuery,
          onSelected: _ctx.sendSelect,
          onSearched: _ctx.sendSearched
        }, null, 8, ["defaultQuery", "onSelected", "onSearched"]),
        (_ctx.showImport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("input", {
                type: "file",
                style: {"display":"none"},
                ref: "bibUploadInput",
                accept: ".bib",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.parseBib && _ctx.parseBib(...args)))
              }, null, 544),
              _hoisted_5,
              _createElementVNode("button", {
                class: "underline hover:no-underline",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadBib && _ctx.uploadBib(...args)))
              }, " Import BibTeX file ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "button-violet",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchClick && _ctx.searchClick(...args)))
        }, [
          _createVNode(_component_SearchIcon, { class: "h-5 w-5 text-white" })
        ])
      ])
    ])
  ]))
}